/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import { useTheme, Box} from '@mui/material';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IUserContextModel } from '../service/model/IUserContextModel';
import UserContextService from '../service/UserContextService';

const root = css({
    display: "flex",
    flexDirection:"column"
})

const GuestLayout = (): JSX.Element => {

    const [user, setUser] = useState<IUserContextModel | undefined>();
    const [userErrors, setUserErrors] = useState<string[]>([]);

    //useEffect(() => {
    //    let isMounted = true; //Avoid memory leaks. Async function running after dismount.
    //    const service = new UserContextService();
    //    const getData = async () => {

    //        //const result = await service.getUserContext(organizationId);
    //        //if (!result.hasErrors) {
    //        //    if (isMounted) {
    //        //        setUser(result.value);
    //        //        i18n.changeLanguage(result.value.language.replace(/-/g, ""));
    //        //        setUserErrors([]);
    //        //    }
    //        //} else {
    //        //    setUserErrors(result.errors);
    //        //}
    //    };
    //    getData();

    //    return () => { isMounted = false };
    //}, [])

    //##################################################################
    //########################Language Config###########################
    const { t, i18n } = useTranslation();
    //##################################################################
    //##################################################################

    const theme = useTheme();

    return <div css={root}>
        <Outlet />
    </div>

}

export default GuestLayout;